// ClickUp F-CU16b (ASK-129's queued socket-binder F leg) — procedural geometry that carries FEED
// imagery speaks glTF's UV convention, the same as every asset.
//
// The ASK-129 ruling made the runtime bind product images with `flipY = false`: `v = 0` is the image
// TOP, as GLTFLoader does and as every authored GLB assumes. That is right for GLB geometry, and it is
// the ONLY option for a KTX2 cover (a compressed upload cannot be flipped). But three.js's own
// primitives — `BoxGeometry`, `PlaneGeometry` — put `v = 1` at the TOP. The socket comic (featured-comic
// stand, pile-table) is a `BoxGeometry`, so after the ruling its cover drew upside down: Shaun's report
// picture on demo-store's round table. MEASURED in node: BoxGeometry face +Z → top vertices v=1,
// bottom v=0.
//
// The fix is the geometry, never the texture: flipping the texture would need a second convention
// (the thing the ruling deleted) and cannot reach a KTX2 hero at all.

/** Flip `v` in place so `v = 0` is the top edge (glTF convention). Idempotent — a geometry already
 *  converted is left alone, so a shared/cached geometry can never be flipped back. */
export function toGltfUv(geometry) {
	const uv = geometry?.attributes?.uv;
	if (!uv) return geometry;
	geometry.userData ||= {};
	if (geometry.userData.uvConvention === "gltf") return geometry;
	for (let i = 0; i < uv.count; i++) uv.setY(i, 1 - uv.getY(i));
	uv.needsUpdate = true;
	geometry.userData.uvConvention = "gltf";
	return geometry;
}
